export var storyStyle = [
    {
        state: 'Blinkl Stories',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Blinkl Stories'
    },
    {
        state: 'Fisheye Gallery',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Fisheye Gallery'
    },
    {
        state: 'Fisheye Magazine',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Fisheye Magazine'
    },
    {
        state: 'Gacilly',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Gacilly'
    },
    {
        state: 'Carquefou',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Carquefou'
    },
    {
        state: 'Arles',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Arles'
    },
    {
        state: 'Visa',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Visa'
    },
    {
        state: 'Yellow Korner',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Yellow Korner'
    },
    {
        state: 'Vincent Munier',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Vincent Munier'
    },
    {
        state: 'Com&Medias',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Com&Medias'
    },
    {
        state: 'Initial Labo',
        desc: 'Ce style de story vous permet de créer votre page de contenu avec une identité Initial Labo'
    }
];
